import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { SYNC_DONE_DELAY_MS, SYNC_STATUS, WELCOME_ERROR } from '../constants';

const redirectByStatus = {
  [SYNC_STATUS.ready]: '/calendar/welcome',
  [SYNC_STATUS.failed]: `/calendar/welcome?error=${WELCOME_ERROR.default}`,
};

const delayByStatus = {
  [SYNC_STATUS.ready]: SYNC_DONE_DELAY_MS,
};

const useSyncStatusRedirect = status => {
  const history = useHistory();

  useEffect(() => {
    const target = redirectByStatus[status];
    if (!target) return undefined;

    const delay = delayByStatus[status];
    if (!delay) {
      history.replace(target);
      return undefined;
    }

    const timerId = setTimeout(() => history.replace(target), delay);

    return () => clearTimeout(timerId);
  }, [history, status]);
};

export default useSyncStatusRedirect;
